module.exports = __webpack_public_path__ + "static/media/20240530085406_IMG_7481.044f2b0d.JPG";